import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
var store = new Vuex.Store({
  state:{
    currentUrl:window.location.origin,//当前URL前缀
  },
  
})
export default store